import Axios from "axios";

export class DirectorioServicio {

    getLista(params) {
        const queryParams = params ? Object.keys(params).map(k => encodeURIComponent(k) + '=' + encodeURIComponent(params[k])).join('&') : '';
        return Axios.get(`${process.env.REACT_APP_URL_BACK}/ficha/directorio-bvg/lista?${queryParams}`).then(res => res.data);
    }

    nuevo(data) {
        return Axios.post(`${process.env.REACT_APP_URL_BACK}/ficha/directorio-bvg/nuevo`, data).then(res => res.data);
    }

    editar(data) {
        return Axios.put(`${process.env.REACT_APP_URL_BACK}/ficha/directorio-bvg/editar`, data).then(res => res.data);
    }

    consultar(id, idp, directorio) {
        return Axios.get(`${process.env.REACT_APP_URL_BACK}/ficha/directorio-bvg/consulta/${id}/${idp}/${directorio}`).then(res => res.data);
    }

    eliminar(id, idp, directorio) {
        return Axios.delete(`${process.env.REACT_APP_URL_BACK}/ficha/directorio-bvg/eliminar/${id}/${idp}/${directorio}`).then(res => res.data);
    }
}
